import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import classnames from 'classnames';

import Styled from 'styled';
import LinkView from 'lib/ui/link-view';
import withCompute from 'lib/mobx/with-compute';
import SVGIconView from 'lib/images/svg-icon-view';
import arrowLeft from 'four-nets/icons/svg/icon_arrow-right.svg';
import defaultStyles from './context-menu-view.scss';

export class ContextMenuItem {
    constructor(link, activeIcon, icon) {
        this.link = link;
        this.activeIcon = activeIcon;
        this.icon = icon;
    }
}

export { ContextMenuViewModel };

@withCompute()
class ContextMenuViewModel {
    @observable collapsed: boolean = true;
    @observable items;
    @observable activeMenuItem;

    constructor(items) {
        this.items = items;
    }

    @action toggleCollapsed = () => {
        this.collapsed = !this.collapsed;
    };

    @action collapse = () => {
        this.collapsed = true;
    };

    @action onLinkClick = (event, link) => {
        this.activeMenuItem = link;
        this.collapse();
    };

    @action setActiveMenuItem = menuItem => {
        this.activeMenuItem = menuItem;
    };
}

@Styled(defaultStyles)
@observer
class ContextMenuView extends React.Component {
    render() {
        const { contextMenuViewModel, dropDown, horizontal, styles } = this.props;
        const { items, collapsed, toggleCollapsed, onLinkClick, activeMenuItem } = contextMenuViewModel;

        const classNames = [styles.contextMenu];

        if (collapsed) {
            classNames.push(styles.collapsed);
        }

        if (dropDown) {
            classNames.push(styles.dropDown);
        }

        if (horizontal) {
            classNames.push(styles.horizontal);
        }

        const style = {
            maxHeight: items.length * 100,
        };

        return (
            <nav className={classNames.join(' ')} style={style}>
                {dropDown ? (
                    <button className={styles.button} onClick={toggleCollapsed}>
                        <span className={styles.headingWrapper}>
                            <h2 className={styles.heading}>
                                <span className={styles.activeIcon}>
                                    {activeMenuItem ? activeMenuItem.activeIcon : null}
                                </span>
                                <span key='text'>{activeMenuItem ? activeMenuItem.link.label : ''}</span>
                            </h2>
                            <SVGIconView src={arrowLeft} className={styles.arrow} />
                        </span>
                    </button>
                ) : null}
                <ul className={styles.list}>
                    {items.map(item => {
                        const itemClassNames = [styles.item];
                        const isActive = item === activeMenuItem;

                        if (isActive) {
                            itemClassNames.push(styles.active);
                        }

                        return (
                            <li key={item.link.label} className={itemClassNames.join(' ')}>
                                <span className={classnames(styles.icon, { [styles.selectedIcon]: isActive })}>
                                    {isActive ? item.activeIcon : item.icon}
                                </span>
                                <LinkView
                                    link={item.link}
                                    className={classnames(styles.link, { [styles.selectedLink]: isActive })}
                                    onClick={event => onLinkClick(event, item)}
                                />
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    }
}

export default ContextMenuView;
